// "company information"
export const DATA_COMPANY = {
  companyName: 'Lexicom',
  tagline: 'Нейротехнологии в помощь гражданам, на службе государства',
};
